import {
	HEADER_HEIGHT,
	HEADER_COLOR,
	HEADER_TITLE_SIZE,
	HEADER_TITLE_COLOR
} from '@/constants';

/**
 * Componente grafico riutilizzabile per l'header delle scene.
 * Aggiunge gli elementi direttamente alla scena.
 *
 * @class Header
 */
export default class Header {
	/**
	 * Crea un nuovo header.
	 *
	 * @constructor
	 * @param {Phaser.Scene} scene - La scena che contiene questo componente.
	 * @param {string} title - Titolo da visualizzare nell'header.
	 */
	constructor(scene, title) {
		const width = scene.sys.game.config.width;
		const centerX = width / 2;
		const headerY = HEADER_HEIGHT / 2;

		this.scene = scene;
		this.title = title;

		// Background dell'header
		this.background = scene.add.rectangle(
			centerX,
			headerY,
			width,
			HEADER_HEIGHT,
			HEADER_COLOR
		);

		// Titolo
		this.titleText = scene.add.text(centerX, headerY, title, {
			fontSize: HEADER_TITLE_SIZE,
			fontFamily: 'Luckiest Guy',
			fill: HEADER_TITLE_COLOR,
			align: 'center',
			stroke: '#1567a3',
			strokeThickness: 2
		}).setOrigin(0.5);
	}

	/**
	 * Restituisce l'altezza dell'header.
	 *
	 * @returns {number} - Altezza dell'header.
	 */
	getHeight() {
		return HEADER_HEIGHT;
	}

	/**
	 * Aggiorna il titolo dell'header.
	 *
	 * @param {string} newTitle - Nuovo titolo da visualizzare.
	 * @returns {Header} - Ritorna this per il chaining.
	 */
	setTitle(newTitle) {
		this.title = newTitle;
		this.titleText.setText(newTitle);
		return this;
	}
}